import { useState } from "react";
import { requestAuth } from "../services/RequestService";
import config from '../../config.json'
import { toast } from "react-toastify";

export const FormDetailsDocument = (props) => {
  console.log("🚀 ~ FormDetailsDocument ~ props:", props);
  const [valoracion, setValoracion] = useState(() => {
    const defaultValues = {
      notaValor: {
        valorFob: 0,
        gastosOrigen: 0.0,
        flete1: 0,
        flete2: 0,
        seguro: 0,
        aspbGastosPuertos: 0,
        otrosGastos: 0,
        cifFronteraDolares: 0,
        cifFronteraBolivianos: 0,
      },
      liquidacionTributos: {
        ga: { baseImponible: 0, tasa: 10, },
        iva: { baseImponible: 0, tasa: 14.94 },
        ice1: { baseImponible: 0, tasa: 0.00 },
        ice2: { baseImponible: 0, tasa: 0.00 },
        mab: { baseImponible: 0, tasa: 0.00 },
        idh: { baseImponible: 0, tasa: 0.00 },
        formDigital: 100,
        suma: 0
      }
    };
    
    if (props.item?.description2) {
      try {
        const parsedData = JSON.parse(props.item.description2);
        
        // Validar que tenga la estructura correcta
        if (!parsedData.notaValor || !parsedData.liquidacionTributos) {
          throw new Error("Objeto mal insertado o datos faltantes");
        }
        
        return {
          notaValor: {
            ...defaultValues.notaValor,
            ...parsedData.notaValor
          },
          liquidacionTributos: {
            ...defaultValues.liquidacionTributos,
            ...parsedData.liquidacionTributos
          }
        };
      } catch (error) {
        console.error("Error: Objeto mal insertado o datos faltantes:", error);
        return defaultValues;
      }
    } else {
      return defaultValues;
    }
  });

  // Función para calcular CIF Frontera Dólares
    const calcularCifFronteraDolares = (notaValor) => {
      const suma = (notaValor.valorFob || 0) +
                  (notaValor.gastosOrigen || 0) +
                  (notaValor.flete1 || 0) +
                  (notaValor.flete2 || 0) +
                  (notaValor.seguro || 0) +
                  (notaValor.aspbGastosPuertos || 0) +
                  (notaValor.otrosGastos || 0);

      return parseFloat(suma.toFixed(2)); 
    };

  // Función para calcular CIF Frontera Bolivianos
  const calcularCifFronteraBolivianos = (cifDolares) => {
    return Math.round(cifDolares * 6.96);
  };

  // Cálculos automáticos con validaciones
  const calcularImporte = (baseImponible = 0, tasa = 0) => {
    const resultado = (parseFloat(baseImponible) * parseFloat(tasa)) / 100;
    return Math.round(resultado * 100) / 100;
  };

  //CALCULAR BASES IMPONIBLES:
  const calcularBaseImponibleGA = (cifBolivianos) => {
    return Math.round((cifBolivianos));
  };
  const calcularBaseImponibleIVA = (cifBolivianos, importeGA) => {
    return cifBolivianos + importeGA;
  };
  const calcularBaseImponibleICE = (cifBolivianos) => {
    return Math.round((cifBolivianos));
  };
  const calcularBaseImponibleMAB = (cifBolivianos, importeGA) => {
    return cifBolivianos + importeGA;
  };
  // const calcularBaseImponibleIDH = (cifBolivianos) => {
  //   return cifBolivianos
  // };

  const calcularSuma = (liquidacionTributos) => {
    const importes = [
      calcularImporte(liquidacionTributos.ga?.baseImponible, liquidacionTributos.ga?.tasa),
      calcularImporte(liquidacionTributos.iva?.baseImponible, liquidacionTributos.iva?.tasa),
      calcularImporte(liquidacionTributos.ice1?.baseImponible, liquidacionTributos.ice1?.tasa),
      calcularImporte(liquidacionTributos.ice2?.baseImponible, liquidacionTributos.ice2?.tasa),
      calcularImporte(liquidacionTributos.mab?.baseImponible, liquidacionTributos.mab?.tasa),
      calcularImporte(liquidacionTributos.idh?.baseImponible, liquidacionTributos.idh?.tasa)
    ];
    
    const suma = importes.reduce((total, importe) => total + importe, 0);
    return Math.round(suma * 100) / 100;
  };

const calcularImporteAPagar = () => {
  const sumaTributos = valoracion.liquidacionTributos.suma || 0;
  const formDigital = valoracion.liquidacionTributos.formDigital || 100;
  
  const resultado = sumaTributos + formDigital;
  
  return Math.round(resultado * 100) / 100;
};

  const payload = {
    id: props.item.id,
    label: props.item.label,
    description: props.item.description || "Datos generales",
    description2: JSON.stringify(valoracion),
    description3: props.item.description3,
    description4: props.item.description4,
    description5: props.item.description5,
    refVoucherEgressId: props.item.refVoucherEgressId,
    refVoucherEgressItemId: props.item.refVoucherEgressItemId,
    observation: props.item.observation,
    stringValue: props.item.stringValue,
    numberValue: props.item.numberValue,
    dataSetId: props.item.dataSetId,
    procedureId: props.item.procedureId,
    fieldId: props.item.fieldId,
    recibo: props.item.recibo,
    order: props.item.order,
    details: props.item.details,
    creationDate: props.item.creationDate,
    endDate: props.item.endDate || new Date().toISOString(),
  };

  const handleNotaValorChange = (e) => {
    const { name, value } = e.target;
    const newNotaValor = {
      ...valoracion.notaValor,
      [name]: parseFloat(value) || 0,
    };
    
    // Calcular automáticamente CIF Frontera
    const cifDolares = calcularCifFronteraDolares(newNotaValor);
    const cifBolivianos = calcularCifFronteraBolivianos(cifDolares);
    
    newNotaValor.cifFronteraDolares = cifDolares;
    newNotaValor.cifFronteraBolivianos = cifBolivianos;
    
    // NUEVO: Calcular automáticamente las bases imponibles
    const baseGA = calcularBaseImponibleGA(cifBolivianos);
    const importeGA = calcularImporte(baseGA, valoracion.liquidacionTributos.ga?.tasa || 10);
    const baseIVA = calcularBaseImponibleIVA(cifBolivianos, importeGA);
    const baseICE = calcularBaseImponibleICE(cifBolivianos);
    const baseMAB = calcularBaseImponibleMAB(cifBolivianos, importeGA);

    // Actualizar las bases imponibles automáticamente
    const newLiquidacionTributos = {
      ...valoracion.liquidacionTributos,
      ga: {
        ...valoracion.liquidacionTributos.ga,
        baseImponible: baseGA
      },
      iva: {
        ...valoracion.liquidacionTributos.iva,
        baseImponible: baseIVA
      },
      ice1: {
        ...valoracion.liquidacionTributos.ice1,
        baseImponible: baseICE
      },
      mab: {
        ...valoracion.liquidacionTributos.mab,
        baseImponible: baseMAB
      },
    };
    
    // Recalcular suma
    newLiquidacionTributos.suma = calcularSuma(newLiquidacionTributos);
    
    setValoracion(prev => ({
      ...prev,
      notaValor: newNotaValor,
      liquidacionTributos: newLiquidacionTributos
    }));
  };

  const handleTributoChange = (tributo, campo, valor) => {
    setValoracion((prev) => {
      const newLiquidacionTributos = {
        ...prev.liquidacionTributos,
        [tributo]: {
          ...(prev.liquidacionTributos[tributo] || { baseImponible: 0, tasa: 0 }),
          [campo]: parseFloat(valor) || 0,
        }
      };
      
      // NUEVO: Si se cambió la tasa de GA, recalcular base imponible de IVA
      if (tributo === 'ga' && campo === 'tasa') {
        const cifBolivianos = prev.notaValor.cifFronteraBolivianos;
        const nuevaTasaGA = parseFloat(valor) || 0;
        const baseGA = newLiquidacionTributos.ga.baseImponible;
        const importeGA = calcularImporte(baseGA, nuevaTasaGA);
        const baseIVA = calcularBaseImponibleIVA(cifBolivianos, importeGA);
        
        newLiquidacionTributos.iva = {
          ...newLiquidacionTributos.iva,
          baseImponible: baseIVA
        };
      }
      
      // Recalcular y guardar la suma automáticamente
      newLiquidacionTributos.suma = calcularSuma(newLiquidacionTributos);
      
      return {
        ...prev,
        liquidacionTributos: newLiquidacionTributos
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // NUEVO: Actualizar el monto con el importe calculado
      const updatedPayload = {
        ...payload,
        description: calcularImporteAPagar().toString() // Actualizar el monto
      };
      
      await requestAuth("PUT", `${config.requestURL}/api/DataSet/procedure/subData/${props.item.id}`, updatedPayload);
      toast.success("Datos actualizados correctamente ", { position: "bottom-right", autoClose: 1000 });
      if (props.reload) {
        props.reload(); // -> actualizará la tabla principal
      }
    } catch {
      toast.error("Error al actualizar", { position: "bottom-right", autoClose: 3000 });
    }
  }
  

  if (!props.item) return <p>Cargando...</p>

  return (
    <div>
      <div className="px-4">
        <form onSubmit={handleSubmit}>
          <div className="flex flex-row gap-4">
            {/* TABLA 1 */}
            <div className="bg-white rounded-xl shadow-md p-4 w-full max-w-sm text-sm">
              <h2 className="text-center font-bold text-base border-b pb-2 mb-3">NOTA DE VALOR</h2>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">Valor Fob</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="valorFob" value={valoracion.notaValor.valorFob} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">Gastos en Origen</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="gastosOrigen" value={valoracion.notaValor.gastosOrigen} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">Flete 1</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="flete1" value={valoracion.notaValor.flete1} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">Flete 2</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="flete2" value={valoracion.notaValor.flete2} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">Seguro</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="seguro" value={valoracion.notaValor.seguro} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                <div className="col-span-6">ASPB/Gastos Puertos</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="aspbGastosPuertos" value={valoracion.notaValor.aspbGastosPuertos} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b mb-2">
                <div className="col-span-6">OTROS G (BAF-HANDLING-THC)</div>
                <div className="col-span-2">
                  <input type="number" className="w-full px-1 py-0.5 border rounded text-right text-sm" name="otrosGastos" value={valoracion.notaValor.otrosGastos} onChange={handleNotaValorChange}/>
                </div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 border-b font-medium">
                <div className="col-span-6">CIF Frontera $us</div>
                <div className="col-span-2 text-right">{valoracion.notaValor.cifFronteraDolares}</div>
              </div>

              <div className="grid grid-cols-8 gap-1 py-1.5 font-medium">
                <div className="col-span-6">CIF Frontera Bs</div>
                <div className="col-span-2 text-right">{valoracion.notaValor.cifFronteraBolivianos}</div>
              </div>
            </div>

            {/* TABLA 2 */}
            <div className="bg-white rounded-xl shadow-md p-4 w-full max-w-xl text-sm">
                <h2 className="text-center font-bold text-base border-b pb-2 mb-3">LIQUIDACION DE TRIBUTOS POR ITEM</h2>
                
                <div className="grid grid-cols-8 gap-1 font-medium pb-1.5 border-b mb-2">
                    <div className="col-span-2">TIPO</div>
                    <div className="col-span-2 text-right">BASE IMPONIBLE</div>
                    <div className="col-span-2 text-right pr-2">TASA</div>
                    <div className="col-span-2 text-right">IMPORTE BS</div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                    <div className="col-span-2">GA</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ga?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('ga', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ga?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('ga', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.ga?.baseImponible, valoracion.liquidacionTributos.ga?.tasa)}
                    </div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                    <div className="col-span-2">IVA</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.iva?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('iva', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.iva?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('iva', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.iva?.baseImponible, valoracion.liquidacionTributos.iva?.tasa)}
                    </div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                    <div className="col-span-2">ICE</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ice1?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('ice1', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ice1?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('ice1', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.ice1?.baseImponible, valoracion.liquidacionTributos.ice1?.tasa)}
                    </div>
                </div>
                
                {/* <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                    <div className="col-span-2">ICE</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ice2?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('ice2', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.ice2?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('ice2', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.ice2?.baseImponible, valoracion.liquidacionTributos.ice2?.tasa)}
                    </div>
                </div> */}
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b">
                    <div className="col-span-2">MAB</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.mab?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('mab', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.mab?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('mab', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.mab?.baseImponible, valoracion.liquidacionTributos.mab?.tasa)}
                    </div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b mb-2">
                    <div className="col-span-2">IDH</div>
                    <div className="col-span-2">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.idh?.baseImponible || 0}
                          onChange={(e) => handleTributoChange('idh', 'baseImponible', e.target.value)}
                        />
                    </div>
                    <div className="col-span-2 flex flex-row gap-1 items-center">
                        <input 
                          type="number" 
                          className="w-full px-1 py-0.5 border rounded text-right text-sm" 
                          value={valoracion.liquidacionTributos.idh?.tasa || 0}
                          step="0.01"
                          onChange={(e) => handleTributoChange('idh', 'tasa', e.target.value)}
                        />
                        <label>%</label>
                    </div>
                    <div className="col-span-2 text-right font-medium">
                      {calcularImporte(valoracion.liquidacionTributos.idh?.baseImponible, valoracion.liquidacionTributos.idh?.tasa)}
                    </div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b font-medium">
                    <div className="col-span-6">Suma</div>
                    <div className="col-span-2 text-right">{valoracion.liquidacionTributos.suma || 0}</div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 border-b font-medium">
                    <div className="col-span-6">Form Digital</div>
                    <div className="col-span-2 text-right">{valoracion.liquidacionTributos.formDigital || 100}</div>
                </div>
                
                <div className="grid grid-cols-8 gap-1 py-1.5 font-bold text-base">
                    <div className="col-span-6">Importe a Pagar</div>
                    <div className="col-span-2 text-right">{calcularImporteAPagar()}</div>
                </div>
            </div>

          </div>
          <div className="mb-4 flex justify-end">
            <button type="submit" className="mt-4 bg-yellow-400 font-bold border-lime-600 text-black px-4 py-2 rounded">Guardar Cambios</button>
          </div>
        </form>
      </div>
    </div>
  );
};